export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'BOUNDARIES_SET':
      return payload
    case 'BOUNDARY_CREATE':
      return [...state, payload]
    case 'BOUNDARY_UPDATE':
      return state.map(item => (item.id === payload.id ? payload : item))
    case 'BOUNDARY_DELETE':
      return state.filter(item => item.id !== payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
